import { navigate } from "gatsby";

import create from "zustand";

import { errorAwareChekoutFetch } from "../../../../../apiBindings";
import pushToAnalytics from "../../../../../utils/analytics";
import {
    storageLocal as storage,
    storageSession as session,
} from "../../../../../utils/StorageHandler";
import resolveWebView from "../../../../../utils/webViewRedirect";
import iCheckoutData from "../../interfaces/iCheckoutData";
import iContact from "../../interfaces/iContact";
import iNotify from "../../interfaces/iNotify";

interface iHeatingOilStepOverview {
    overlayContent: string;
    loading: boolean;
    order: unknown;
    contact: iContact;
    checkoutIsExpired: boolean;
    checkoutIsExpiredErrorMessage: string;
    setOverlayContent: (overlayContent: string) => void;
    setCheckoutIsExpired: (value: boolean) => void;
    sendOrderToServer: (
        checkoutData: iCheckoutData,
        newsletterChecked: boolean,
        agbChecked: boolean,
        voucher: string,
        notify: iNotify
    ) => Promise<iCheckoutData>;
}

const useStore = create<iHeatingOilStepOverview>((set, get) => ({
    overlayContent: "",
    loading: false,
    order: session.getJson("hel:order", {}),
    contact: storage.getJson("hel:order-contact", {
        team_name: "",
        street: "",
        zipcode: "",
        city: "",
        phone: "",
        email: "",
    }),
    checkoutIsExpired: false,
    checkoutIsExpiredErrorMessage: "",

    setOverlayContent: (overlayContent: string) => {
        set({ overlayContent: overlayContent });
    },

    uebersichtStepIsValid: () => {
        return true;
    },

    sendOrderToServer: async (
        checkoutData,
        newsletterChecked,
        agbChecked,
        voucher,
        notify
    ): Promise<iCheckoutData> => {
        const checkoutDataResponse = { ...checkoutData };
        set({ loading: true });
        const data = {
            hash: checkoutData.user_hash,
            newsletter: newsletterChecked,
            agbChecked: agbChecked,
            voucher,
        };
        await errorAwareChekoutFetch<{ data: any }>(
            `/heatingoil/checkout/finish`,
            {
                method: "POST",
                body: JSON.stringify(data),
            }
        )
            .then(({ data }) => {
                session.setJson("hel:order", data.order);
                storage.setJson("hel:order-contact", data.contact);
                storage.set("app:uid", data.appUid);

                pushToAnalytics("order", {
                    orderNumber: data.order.order_number,
                });
                set({ order: data.order });
                set({ contact: data.contact });
            })
            .catch(({ data }) => {
                notify("Fehlgeschlagen", data.message);
                navigate(resolveWebView("/heizoel/bestellung/uebersicht/"));
                if (data.checkoutExpired) {
                    set({ checkoutIsExpired: true });
                    set({ checkoutIsExpiredErrorMessage: data.message });
                }
            });
        set({ loading: false });
        return checkoutDataResponse;
    },
    setCheckoutIsExpired: (value) => {
        set({ checkoutIsExpired: value });
    },
}));

export default useStore;
